import { initialErrors } from '../Constants/Cities.constants';
import { Types } from '../Constants/Types';
import CityType from '../Interfaces/cities.interface';

const CitiesReducer = (
  state: CityType['status'] = {
    city: undefined,
    cities: [],
    lcities: false,
    lcity: false,
    ldelete: false,
    error: initialErrors,
  },
  action: CityType['action']
) => {
  switch (action.type) {
    case Types.FETCH_CITIES:
      return {
        ...state,
        cities: action.payload,
      };

    case Types.FETCH_CITY:
      return { ...state, city: action.payload };

    case Types.CREATE_CITY:
      return { ...state, cities: [action.payload, ...state.cities] };

    case Types.DELETE_CITY:
      return {
        ...state,
        cities: state.cities.filter((city) => city._id !== action.payload),
      };

    case Types.UPDATE_CITY:
      return {
        ...state,
        cities: state.cities.map((city) =>
          city._id === action.payload._id ? action.payload : city
        ),
      };

    case Types.TOGGLE_CITY_ACTIVE:
      return {
        ...state,
        cities: state.cities.map((city) =>
          city._id === action.payload.id
            ? { ...city, isActive: action.payload.isActive }
            : city
        ),
      };

    case Types.START_CITIES:
      return { ...state, lcities: true };

    case Types.END_CITIES:
      return { ...state, lcities: false };

    case Types.START_CITY:
      return { ...state, lcity: true };

    case Types.END_CITY:
      return { ...state, lcity: false };

    case Types.ERROR_CITY:
      return {
        ...state,
        error: action?.payload
          ? { ...state.error, [action?.field!]: action.payload }
          : { ...state.error, [action?.field!]: null },
      };

    case Types.MAIN_ERROR:
      return { ...state, error: { ...state.error, main: action.payload } };

    default:
      return state;
  }
};

export default CitiesReducer;
